let thumbs_swiper;
if (window.innerWidth > 1040) {
  const mainSliderHeight = document.querySelector('.slideshow.product-slideshow.desktop').offsetHeight;
  
  document.querySelector('.thumbnails.swiper').style.height = `${mainSliderHeight}px`;
  
  thumbs_swiper = new Swiper(".thumbnails", {
    spaceBetween: 20,
    slidesPerView: 'auto',
    direction: "vertical",
    observer: true,
    observeParents: true,
  });
}

const main_swiper_desktop = new Swiper(".slideshow.product-slideshow.desktop", {
  // Optional parameters
  slidesPerView: 1,
  observer: true,
  observeParents: true,
  thumbs: {
    swiper: thumbs_swiper,
  },
  navigation: {
    nextEl: ".slick-product-next",
    prevEl: ".slick-product-prev",
  },
});

const main_swiper_mobile = new Swiper(".slideshow.product-slideshow.mobile", {
  // Optional parameters
  slidesPerView: 1,
  observer: true,
  observeParents: true,
  thumbs: {
    swiper: thumbs_swiper,
  },
  navigation: {
    nextEl: ".slick-product-next",
    prevEl: ".slick-product-prev",
  },
});

const color_options = document.querySelectorAll(
  ".option-selector__btns input.js-option"
);
const variant_images = document.querySelectorAll(
  ".slideshow.product-slideshow .slide"
);
const thumb_images = document.querySelectorAll(".thumbnails.swiper .thumbnail");
const color_options_label = document.querySelectorAll(
  ".option-selector__btns .opt-label"
);
const main_container = document.querySelectorAll(
  ".slideshow.product-slideshow .swiper-wrapper"
);
const thumbs_container = document.querySelectorAll(
  ".thumbnails.swiper .swiper-wrapper"
);
let data_images = [];
let data_thumbs = [];
let active_option = "";

function initDefaultOptions() {
  const variantData = theme.OptionManager.getCurrentVariantData(
    $(".product-form")
  );
  active_option = `${variantData.option1},${variantData.option3 ?? "-"}`;
  const productData = theme.OptionManager.getProductData($(".product-form"));
  productData.variants.forEach((variant) => {
    const groupName = `${variant.option1},${variant.option3 ?? "-"}`;
    if (
      data_images.some((imageObject) => imageObject.option_name === groupName)
    ) {
      return;
    }
    const img_object = {
      option_name: groupName,
      option_images: [
        ...(document.querySelectorAll(
          `.slideshow.product-slideshow.desktop [data-variant-image-group="${groupName}"]`
        ).length > 0
          ? document.querySelectorAll(
              `.slideshow.product-slideshow.desktop [data-variant-image-group="${groupName}"]`
            )
          : document.querySelectorAll(
              `.slideshow.product-slideshow.desktop [data-variant-image-group]`
            )),
      ],
    };
    data_images.push(img_object);

    if (window.innerWidth > 1040) {
      const thumb_object = {
        option_name: groupName,
        option_images: [
          ...(document.querySelectorAll(
            `.thumbnails.swiper [data-variant-image-group="${groupName}"]`
          ).length > 0
            ? document.querySelectorAll(
                `.thumbnails.swiper [data-variant-image-group="${groupName}"]`
              )
            : document.querySelectorAll(
                `.thumbnails.swiper [data-variant-image-group]`
              )),
        ],
      };
      data_thumbs.push(thumb_object);
    }
  });

  setTimeout(() => {
    const active_img = data_images.find(
      (el) => el.option_name === active_option
    );

    variant_images.forEach((image) => {
      image.remove();
    });

    active_img.option_images.forEach((el) => {
      main_container.forEach((item) => {
        item.insertAdjacentHTML("beforeend", el.innerHTML);
      });
    });

    main_swiper_desktop.update();
    main_swiper_mobile.update();

    if (window.innerWidth > 1040) {
      const active_thumb = data_thumbs.find(
        (el) => el.option_name === active_option
      );

      thumb_images.forEach((image) => {
        image.remove();
      });

      active_thumb.option_images.forEach((el) => {
        thumbs_container.forEach((item) => {
          item.insertAdjacentHTML("beforeend", el.innerHTML);
        });
      });

      thumbs_swiper.update();
      updateThumbsHeight();
    }
  }, 300);
}

function setOPtions() {
  $(window).on("cc-variant-updated", (e, args) => {
    const curent_value = `${args.variant.option1},${
      args.variant.option3 ?? "-"
    }`;
    const current_variant_images = document.querySelectorAll(
      ".slideshow.swiper .swiper-slide"
    );
    const current_variant_thumbs = document.querySelectorAll(
      ".thumbnails.swiper .swiper-slide"
    );

    const active_img = data_images.find(
      (el) => el.option_name === curent_value
    );
    if (!active_img) {
      return;
    }
    current_variant_images.forEach((image) => {
      image.remove();
    });

    active_img.option_images.forEach((el) => {
      main_container.forEach((item) => {
        item.insertAdjacentHTML("beforeend", el.innerHTML);
      });
    });

    main_swiper_desktop.update();
    main_swiper_mobile.update();

    if (window.innerWidth > 1040) {
      current_variant_thumbs.forEach((image) => {
        image.remove();
      });

      const active_thumb = data_thumbs.find(
        (el) => el.option_name === curent_value
      );

      active_thumb.option_images.forEach((el) => {
        thumbs_container.forEach((item) => {
          item.insertAdjacentHTML("beforeend", el.innerHTML);
        });
      });
      thumbs_swiper.update();
      updateThumbsHeight();
    }
  });
  // });
}

function videoPlay() {
  main_swiper_desktop.on("realIndexChange", function () {
    setTimeout(() => {
      const active_slide = document.querySelector(
        ".main-image .swiper-slide-active"
      );
      const prev_slide = document.querySelector(".swiper-slide-prev");
      const next_slide = document.querySelector(".swiper-slide-next");

      if (active_slide) {
        const poster = active_slide.querySelector(".product-media__poster");
        const video = active_slide.querySelector("video");
        if (video) {
          poster.style.display = "none";
          if (video.paused) {
            video.play();
          }
        }
      }

      if (prev_slide) {
        const poster = prev_slide.querySelector(".product-media__poster");
        const video = prev_slide.querySelector("video");
        if (video) {
          poster.style.display = "block";
          video.pause();
        }
      }

      if (next_slide) {
        const poster = next_slide.querySelector(".product-media__poster");
        const video = next_slide.querySelector("video");
        if (video) {
          poster.style.display = "block";
          video.pause();
        }
      }
    }, 100);
  });
  main_swiper_mobile.on("realIndexChange", function () {
    setTimeout(() => {
      const active_slide = document.querySelector(".swiper-slide-active");
      const prev_slide = document.querySelector(".swiper-slide-prev");
      const next_slide = document.querySelector(".swiper-slide-next");

      if (active_slide) {
        const poster = active_slide.querySelector(".product-media__poster");
        const video = active_slide.querySelector("video");
        if (video) {
          poster.style.display = "none";
          if (video.paused) {
            video.play();
          }
        }
      }

      if (prev_slide) {
        const poster = prev_slide.querySelector(".product-media__poster");
        const video = prev_slide.querySelector("video");
        if (video) {
          poster.style.display = "block";
          video.pause();
        }
      }

      if (next_slide) {
        const poster = next_slide.querySelector(".product-media__poster");
        const video = next_slide.querySelector("video");
        if (video) {
          poster.style.display = "block";
          video.pause();
        }
      }
    }, 100);
  });
}

function updateThumbsHeight() {
  if (window.innerWidth > 1040) {
    setTimeout(() => {
      const mainSlider = document.querySelector('.slideshow.product-slideshow.desktop');
      const thumbnailsContainer = document.querySelector('.thumbnails.swiper');
      
      if (mainSlider && thumbnailsContainer) {
        const mainSliderHeight = mainSlider.offsetHeight;
        
        if (mainSliderHeight > 0) {
          thumbnailsContainer.style.height = `${mainSliderHeight}px`;
          if (thumbs_swiper) {
            thumbs_swiper.update();
          }
        }
      }
    }, 100);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    initDefaultOptions();
    setOPtions();
    videoPlay();
    
    updateThumbsHeight();
    
    window.addEventListener('resize', () => {
      updateThumbsHeight();
    });
  }, 350);
});

// Check and send quiz view event
let quizViewEventSent = false;

function sendQuizViewEvent() {
  if (quizViewEventSent) return;

  console.log("Checking GTM availability...");
  if (typeof window.gtag === "undefined") {
    console.warn("GTM is not initialized yet");
    return false;
  }

  const targetSection = document.querySelector("#quiz-main-wrapper");
  if (!targetSection) {
    console.warn("Quiz section not found");
    return false;
  }

  let previousPages = [];
  try {
    const rawHistory = sessionStorage.getItem("quiz_path_history");
    if (rawHistory) {
      previousPages = JSON.parse(rawHistory);
    }
  } catch (e) {
    console.warn("Could not parse quiz_path_history:", e);
  }

  // ✅ Send the event to GTM
  console.log("Sending quiz view event...");
  gtag("event", "quiz_view", {
    quiz_step: "view",
    quiz_type: "shade_finder",
    previous_pages: JSON.stringify(previousPages),
  });

  // ✅ Clear the session storage
  sessionStorage.removeItem("quiz_path_history");
  console.log("✅ Quiz view event sent with path history");

  quizViewEventSent = true;
  return true;
}

// Try to send event when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  if (!sendQuizViewEvent()) {
    setTimeout(sendQuizViewEvent, 1500);
  }
});

// Try to send event when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  // First attempt
  if (!sendQuizViewEvent()) {
    // If failed, try again after a short delay to ensure GTM is loaded
    setTimeout(sendQuizViewEvent, 1500);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const quizSteps = document.querySelectorAll(".quiz-wrapper");
  const progressSteps = document.querySelectorAll(".quiz-progress-step");
  const quizResults = [];
  let currentStep = 0;
  const restartButton = document.querySelectorAll(
    ".quiz_product__header--restart button"
  );
  const quizModal = document.querySelector("#quiz-modal");
  const quizModalContent = document.querySelector("#quiz-modal-text");
  const quizModalClose = document.querySelector(".quiz-modal__close");

  const resetQuiz = () => {
    // Reset current step
    currentStep = 0;

    // Clear quiz results
    quizResults.length = 0;

    // Reset inputs
    const inputs = document.querySelectorAll(
      ".quiz-answers input[type='radio'], .quiz-answers input[type='checkbox']"
    );
    inputs.forEach((input) => {
      input.checked = false;
    });

    // Reset active classes on steps
    quizSteps.forEach((step, index) => {
      step.classList.toggle("active", index === 0);
    });

    // Reset progress bar
    progressSteps.forEach((step, index) => {
      step.classList.remove("active", "completed");
      if (index === 0) {
        step.classList.add("active");
      }
    });

    // Hide product block
    const quizProductBlock = document.getElementById("quiz-product");
    if (quizProductBlock) {
      quizProductBlock.classList.add("hidden-product");
    }

    console.log("Quiz restarted");
  };

  // Attach event listener to the restart button
  restartButton.forEach((button) => {
    button.addEventListener("click", resetQuiz);
  });

  const openModal = (content) => {
    quizModalContent.innerHTML = content;
    quizModal.style.display = "flex";
  };

  const closeModal = () => {
    quizModal.style.display = "none";
  };

  quizModalClose.addEventListener("click", closeModal);

  document.addEventListener("click", (e) => {
    if (e.target === quizModal) {
      closeModal();
    }
  });

  const initializeModalButtons = () => {
    const infoButtons = document.querySelectorAll(".quiz-info__button");
    infoButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const infoContent =
          button.closest(".quiz-info")?.nextElementSibling?.innerHTML;
        if (infoContent) {
          openModal(infoContent);
        } else {
          console.warn("No content found for modal.");
        }
      });
    });
  };

  const updateProgressBar = () => {
    progressSteps.forEach((step, index) => {
      step.classList.remove("active", "completed");
      if (index < currentStep) {
        step.classList.add("completed");
      } else if (index === currentStep) {
        step.classList.add("active");
      }
    });
  };

  const showStep = (step) => {
    quizSteps.forEach((stepElement, index) => {
      stepElement.classList.toggle("active", index === step);
    });
    updateProgressBar();
    initializeScrollButtonsForStep(step);
  };

  const updateButtonState = (step) => {
    const stepElement = quizSteps[step];
    const inputs = stepElement.querySelectorAll("input");
    const nextButton = stepElement.querySelector(".next-button");
    nextButton.disabled = !Array.from(inputs).some((input) => input.checked);
  };

  const updatePreviousButtonState = (step) => {
    const previousButton = quizSteps[step]?.querySelector(".previous-button");
    if (previousButton) {
      previousButton.disabled = step === 0;
    }
  };

  const saveStepResult = (step) => {
    const stepElement = quizSteps[step];
    const questionText =
      stepElement.querySelector(".quiz-question h2").textContent;
    const inputs = stepElement.querySelectorAll("input");

    const answers = Array.from(inputs)
      .filter((input) => input.checked)
      .map((input) => ({
        value: input.value,
        options:
          input
            .closest(".quiz-answer")
            .dataset.options?.split(";")
            .map((opt) => opt.trim()) || [],
      }));

    quizResults[step] = { question: questionText, answers };
  };

  const computeOptionCounts = () => {
    const optionCounts = {};

    quizResults.forEach((result) => {
      result.answers.forEach((answer) => {
        answer.options.forEach((option) => {
          if (option) {
            optionCounts[option] = (optionCounts[option] || 0) + 1;
          }
        });
      });
    });

    const sortedOptionCounts = Object.entries(optionCounts).sort(
      ([, countA], [, countB]) => countB - countA
    );

    const mostPopularColor = sortedOptionCounts.find(([option]) =>
      option.toLowerCase().includes("shade")
    )?.[0];

    // Send to Google Analytics after quiz completion
    if (window.gtag) {
      gtag("event", "quiz_completion", {
        quiz_step: "completed",
        shade_selected: mostPopularColor || "Not Selected",
        quiz_type: "shade_finder",
      });
      console.log("✅ Sent to Google Analytics after quiz_completion", {
        shade_selected: mostPopularColor || "Not Selected",
      });
    } else {
      console.warn("❌ GTM undefined");
    }

    selectColorAndSize(mostPopularColor);
    console.log("Most Popular Color:", mostPopularColor || "None");
  };

  const selectColorAndSize = (color) => {
    console.log("Selecting color:", color);

    // Handle color swatch click
    if (color) {
      const colorSwatch = document.querySelector(
        `.opt-label[data-variant-group="${color}"]`
      );
      if (colorSwatch) {
        const productQuizColorResult = document.querySelectorAll(
          ".js-quiz-color-result"
        );
        productQuizColorResult.forEach((element) => {
          element.textContent = color;
        });
        setTimeout(() => {
          colorSwatch.click();
          const productWraper = document.querySelector("#quiz-product");
          productWraper.classList.remove("hidden-product");
          productWraper.scrollIntoView();
        }, 250);
        console.log(`Color "${color}" selected`);
      } else {
        console.warn(`Color swatch for "${color}" not found.`);
      }
    }
  };

  const initializeScrollButtonsForStep = (step) => {
    const quizStep = quizSteps[step];
    const quizAnswers = quizStep.querySelector(".quiz-answers");
    const leftButton = quizStep.querySelector(".scroll-button--left");
    const rightButton = quizStep.querySelector(".scroll-button--right");

    const updateScrollButtons = () => {
      leftButton.disabled = quizAnswers.scrollLeft === 0;
      rightButton.disabled =
        quizAnswers.scrollLeft + quizAnswers.offsetWidth >=
        quizAnswers.scrollWidth;
    };

    leftButton.addEventListener("click", () => {
      const itemWidth =
        quizAnswers.querySelector(".quiz-answer").offsetWidth + 40;
      quizAnswers.scrollBy({ left: -itemWidth, behavior: "smooth" });
    });

    rightButton.addEventListener("click", () => {
      const itemWidth =
        quizAnswers.querySelector(".quiz-answer").offsetWidth + 40;
      quizAnswers.scrollBy({ left: itemWidth, behavior: "smooth" });
    });

    quizAnswers.addEventListener("scroll", updateScrollButtons);
    updateScrollButtons();
  };

  const initializeScrollButtons = () => {
    quizSteps.forEach((step, index) => initializeScrollButtonsForStep(index));
  };

  quizSteps.forEach((stepElement, stepIndex) => {
    const inputs = stepElement.querySelectorAll("input");
    const nextButton = stepElement.querySelector(".next-button");
    const previousButton = stepElement.querySelector(".previous-button");

    updateButtonState(stepIndex);
    updatePreviousButtonState(stepIndex);

    inputs.forEach((input) => {
      input.addEventListener("change", () => updateButtonState(stepIndex));
    });

    if (nextButton) {
      nextButton.addEventListener("click", () => {
        saveStepResult(stepIndex);
        if (stepIndex < quizSteps.length - 1) {
          currentStep += 1;
          showStep(currentStep);
        } else {
          console.log("Quiz Results:", quizResults);
          computeOptionCounts();
        }
      });
    }

    if (previousButton) {
      previousButton.addEventListener("click", () => {
        if (stepIndex > 0) {
          currentStep -= 1;
          showStep(currentStep);
        }
      });
    }
  });

  showStep(currentStep);
  initializeScrollButtons();
  initializeModalButtons();
});

document.addEventListener("DOMContentLoaded", () => {
  const addToCartButton = document.querySelector(
    '#quiz-product .product-purchase-form .button[type="submit"]'
  );
  if (addToCartButton) {
    addToCartButton.addEventListener("click", () => {
      if (window.gtag) {
        gtag("event", "quiz_add_to_cart", {
          quiz_step: "add_to_cart",
          quiz_type: "shade_finder",
        });
      }
    });
  }
});
